import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { isEmpty } from "lodash";
import {
  Button,
  Dimmer,
  Form,
  Loader,
  Message,
  Segment,
  Card,
} from "semantic-ui-react";
import { connect } from "react-redux";
import onlineIcon from "../../assets/images/onlineIcon.png";
import offlineIcon from "../../assets/images/offlineIcon.png";

import { logoutAction } from "../../actions/session";
import MainMenu from "../../components/mainMenu";
import { setActiveMenuPosition } from "../../actions/menu";
import { Api } from "../../utils/api";
import MapContainer from "../../components/mapContainer";
import ErrorMessage from "../../components/errorMessage";
import { validateEmail } from "../../utils/helpers";
import { gql, useMutation } from "@apollo/client";
import { client } from "../../utils/client";

const EditAdmin = (props) => {
  const { session, menu, presets, onLogout, setActiveMenuPosition } = props;
  const [admin, setAdmin] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitErrors, setSubmitErrors] = useState([]);
  const [error, setError] = useState({
    visible: false,
    messages: [],
    header: "",
  });

  const { id, pageName } = useParams();

  const isViewPage = pageName === "view";

  useEffect(() => {
    const getAdmin = async (id) => {
      setLoading(true);
      try {
        const worker = await Api.fetchWorkerById(id);
        setAdmin({
          first_name: worker?.first_name,
          last_name: worker?.last_name,
          isOnline: worker?.isOnline,
          email: worker?.email,
          language_id_code: worker?.language_id_code,
          language: worker?.language,
          about: worker?.about,
          address: worker?.address,
          location: worker?.location,
          city: worker?.city,
        });
      } catch (error) {
        setError(error.response);
      } finally {
        setLoading(false);
      }
    };
    if (loading) {
      getAdmin(id);
    }
  }, []);

  const updateFieldValue = (fieldName, filedValue) => {
    setSubmitErrors([]);
    setAdmin((state) => ({ ...state, [fieldName]: filedValue }));
  };

  const UpdateAdmin = gql`
    mutation UpdateProfile(
      $id: String
      $firstName: String
      $lastName: String
      $email: String
      $language: [Int]
      $about: String
      $address: String
      $location: [Float]
      $city: String
    ) {
      updateProfile(
        id: $id
        firstName: $firstName
        lastName: $lastName
        email: $email
        language: $language
        about: $about
        address: $address
        location: $location
        city: $city
      ) {
        id
      }
    }
  `;

  const [updateAdmin] = useMutation(UpdateAdmin, { client: client });

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = [];
    if (!admin.first_name) {
      errors.push("Please enter first name !");
    }
    if (!admin.last_name) {
      errors.push("Please enter last name !");
    }
    if (!validateEmail(admin.email)) {
      errors.push("Please enter valid email !");
    }
    if (isEmpty(admin.language)) {
      errors.push("Please select langauge !");
    }
    if (!admin.address || isEmpty(admin.location)) {
      errors.push("Please enter address !");
    }
    if (!isEmpty(errors)) {
      setSubmitErrors(errors);
      return;
    }
    try {
      updateAdmin({
        variables: {
          id: id,
          firstName: admin.first_name,
          lastName: admin.last_name,
          email: admin.email,
          language: admin.language,
          about: admin.about,
          address: admin.address,
          location: admin.location,
          city: admin.city,
        },
      }).then(() => (window.location.href = "/#/admins"));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Segment.Group>
      <MainMenu
        needShowPrivateItems={session.isAuthenticated}
        menu={menu}
        onLogout={onLogout}
        setActiveMenuPosition={setActiveMenuPosition}
        userDetails={session.userDetails}
      />
      <Dimmer.Dimmable as={Segment} dimmed={loading || presets.loading}>
        <Dimmer active={loading || presets.loading} inverted>
          <Loader>Loading</Loader>
        </Dimmer>
        <Segment padded>
          {error.visible && (
            <ErrorMessage
              error={error}
              hideError={() => {
                setError((state) => ({
                  ...state,
                  visible: false,
                  header: "",
                  messages: [],
                }));
              }}
            />
          )}
          <Card.Header className="cardHeader">
            <p
              style={{
                maxWidth: "60%",
                minWidth: "60%",
                wordWrap: "break-word",
              }}
            ></p>
            {admin?.isOnline ? (
              <div>
                <img
                  src={onlineIcon}
                  alt="Online Icon"
                  width="15px"
                  height="15px"
                />{" "}
                Online
              </div>
            ) : (
              <div>
                <img
                  src={offlineIcon}
                  alt="Online Icon"
                  width="15px"
                  height="15px"
                />{" "}
                Offline
              </div>
            )}
          </Card.Header>

          <Form onSubmit={handleSubmit}>
            {!loading && (
              <Segment secondary>
                <Form.Group widths="equal">
                  <Form.Input
                    readOnly={isViewPage}
                    fluid
                    label={"First Name (*)"}
                    placeholder="First Name"
                    value={admin.first_name}
                    onChange={(e) => {
                      updateFieldValue("first_name", e.target.value);
                    }}
                  />
                  <Form.Input
                    readOnly={isViewPage}
                    fluid
                    label={"Last Name (*)"}
                    placeholder="Last Name"
                    value={admin.last_name}
                    onChange={(e) => {
                      updateFieldValue("last_name", e.target.value);
                    }}
                  />
                  <Form.Input
                    readOnly={isViewPage}
                    fluid
                    label={"Email (*)"}
                    placeholder="Email"
                    value={
                      `${admin?.email
                        ?.slice(0, 5)
                        ?.padEnd(admin?.email.slice(5)?.length, "X")}` || ""
                    }
                  />
                  <Form.Input
                    readOnly={isViewPage}
                    fluid
                    label={"Language_id_code"}
                    placeholder="Language_id_code"
                    value={admin?.language_id_code}
                  />
                  <Form.Select
                    readOnly={isViewPage}
                    fluid
                    label={"language (*)"}
                    placeholder="language"
                    multiple
                    options={
                      !isEmpty(presets?.value?.languages)
                        ? presets?.value?.languages.map((lang) => {
                            return {
                              ...lang,
                              key: lang.id,
                              text: lang.language,
                              value: lang.id,
                            };
                          })
                        : []
                    }
                    value={!isEmpty(admin?.language) ? admin?.language : []}
                    onChange={(e, { value }) => {
                      !isViewPage && updateFieldValue("language", value);
                    }}
                  />
                </Form.Group>
                <Form.TextArea
                  readOnly={isViewPage}
                  label={"Bio"}
                  placeholder="Bio"
                  value={admin.about ?? ""}
                  onChange={(e) => {
                    updateFieldValue("about", e.target.value);
                  }}
                />
                <div
                  style={{
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <MapContainer
                    latLng={{
                      lat:
                        !isEmpty(admin.location) &&
                        Array.isArray(admin.location)
                          ? admin.location[0]
                          : 0,
                      lng:
                        !isEmpty(admin.location) &&
                        Array.isArray(admin.location)
                          ? admin.location[1]
                          : 0,
                    }}
                    handelChange={(e) => {
                      if (!isViewPage)
                        setAdmin((state) => ({
                          ...state,
                          address: e.formattedAddress,
                          location: [e.latLng.lat, e.latLng.lng],
                          city: e.addressParts.city,
                          zip_code: e.addressParts.zip_code,
                          country_code: e.addressParts.country_code,
                          country: e.addressParts.country,
                        }));
                      setSubmitErrors([]);
                    }}
                    mapStyle={{
                      height: "600px",
                      marginBottom: "40px",
                    }}
                    formattedAddress={admin.address}
                    addressParts={{
                      city: admin?.city,
                      country: admin?.country,
                      zip_code: admin?.zip_code,
                    }}
                    city={admin.city}
                  />
                </div>
                <Form.Input
                  readOnly={isViewPage}
                  fluid
                  label={"Admin Id"}
                  placeholder="Admin Id"
                  value={id}
                />
              </Segment>
            )}
            {!isEmpty(submitErrors) &&
              submitErrors.map((error) => (
                <Message key={error} style={{ display: "block" }} error={true}>
                  {error}
                </Message>
              ))}
            {!isViewPage && (
              <Segment secondary textAlign="center">
                <Link to={"/admins"}>
                  <Button size="large" content="Cancel" />
                </Link>
                <Button
                  size="large"
                  color="blue"
                  content="Save"
                  type="submit"
                />
              </Segment>
            )}
          </Form>
        </Segment>
      </Dimmer.Dimmable>
    </Segment.Group>
  );
};

const mapStateToProps = (state) => {
  return {
    menu: state.menu,
    users: state.users,
    session: state.session,
    presets: state.presets,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout() {
      logoutAction()(dispatch);
    },
    setActiveMenuPosition(activeMenu) {
      setActiveMenuPosition(activeMenu)(dispatch);
    },
  };
};

const createConnect = connect(mapStateToProps, mapDispatchToProps);

export default createConnect(EditAdmin);
